import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PageCTA() {
  return <section className="border-t border-white/10 bg-[#0a0a0a] py-20 sm:py-28" aria-labelledby="page-cta-title" data-id="element-75" data-mp="u3c7fwrgegvj">
      <div className="container mx-auto px-6 md:px-12" data-id="element-76" data-mp="z1nho8lnutea">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.35
      }} transition={{
        duration: 0.5
      }} className="mx-auto grid max-w-5xl overflow-hidden border border-white/15 lg:grid-cols-[1.2fr_0.8fr]" data-id="element-77" data-mp="z49x0uesmd72">
          <div className="p-8 sm:p-12" data-id="element-78" data-mp="25pudf3mp167b">
            <p className="eyebrow" data-id="element-79" data-mp="25osrg4452zat">Una decisión clara</p>
            <h2 id="page-cta-title" className="mt-5 max-w-xl text-3xl font-medium tracking-[-0.045em] text-white sm:text-4xl" data-id="element-80" data-mp="2ainhdpac8aic">
              Demos a tu presencia digital una dirección concreta.
            </h2>
            <p className="mt-5 max-w-xl text-sm leading-relaxed text-neutral-400 sm:text-base" data-id="element-81" data-mp="o884g2dz9ekv">
              Empieza con una oferta completa, un precio definido y una ruta de
              trabajo fácil de seguir.
            </p>
          </div>
          <div className="flex flex-col justify-between border-t border-white/10 bg-white p-8 text-black sm:p-12 lg:border-l lg:border-t-0" data-id="element-82" data-mp="1bykky1nagjn2">
            <div data-id="element-83" data-mp="172n31qwdn586">
              <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-neutral-600" data-id="element-84" data-mp="1l0bmqvepk6bn">
                Oferta Growthly
              </p>
              <p className="mt-4 text-5xl font-medium tracking-[-0.06em]" data-id="element-85" data-mp="1g2ijaa4shqf2">
                350€
              </p>
              <p className="mt-2 text-sm text-neutral-700" data-id="element-86" data-mp="3mrx6vj09tvm2">
                Pago único por transferencia. Sin cuotas mensuales.
              </p>
            </div>
            <div className="mt-9" data-id="element-87" data-mp="1lq8uo6ab09l9">
              <p className="mb-4 flex items-center gap-2 text-xs text-neutral-700" data-id="element-88" data-mp="1lra4k7fl2q1e">
                <CheckIcon size={15} aria-hidden="true" data-id="element-89" data-mp="1qpbpyz0hf1g1" /> Web, carta y gestión
                incluida
              </p>
              <Link to="/checkout" className="group flex items-center justify-center gap-2 bg-black px-5 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-neutral-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 focus-visible:ring-offset-white" data-id="element-90" data-mp="1vppwudqck5ch">
                Solicitar mi proyecto{' '}
                <ArrowRightIcon size={16} className="transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-91" data-mp="2eg7kw508icri" />
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}